import { getIconRenderer } from './getIconRenderer';
import { EIcon } from '../../../../../repositories/dailyrent/entities/offer/Offer';

export interface IPinIconsProps {
  icons: EIcon[];
  isFavorite: boolean;
  isViewed: boolean;
  isHighlighted: boolean;
  /** Пин с каунтером: у него иконки на выделении инвертируются по макету мультипина */
  isMulti: boolean;
}

export function getIcons({ icons, isFavorite, isViewed, isHighlighted, isMulti }: IPinIconsProps): string {
  const iconProps = { isViewed, isHighlighted, isMulti };

  // Порядок после цены — сначала иконки объявлений, затем избранное
  const offerIcons = icons.map(icon => getIconRenderer(icon, iconProps)).join('');
  const favoriteIcon = isFavorite ? getIconRenderer('favorite', iconProps) : '';

  return `${offerIcons}${favoriteIcon}`;
}
